import React from 'react'

import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import closeLogo from 'images/close.svg'

import { SignInForm } from 'components/SignInForm'
import { SignUpForm } from 'components/SignUpForm'

import * as styles from './SignUpSignInModal.module.scss'
import { ForgotPasswordModal } from '../ForgotPasswordModal'

export const SignUpSignInModal = ({
  open,
  handleClose: handleCloseProp,
  isLogin: isLoginProp,
}) => {
  const [openForgotPasswordModal, setOpenForgotPasswordModal] =
    React.useState(false)

  const [isLogin, setIsLogin] = React.useState(isLoginProp)
  const [isSignUpFormFilled, setIsSignUpFormFilled] = React.useState(false)

  const handleClose = () => {
    handleCloseProp()
    setIsSignUpFormFilled(false)
    // Reset the form after closing the modal
    setTimeout(() => {
      setIsLogin(isLoginProp)
    }, 500)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={styles.modal}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          right: 8,
          top: 8,
          alignSelf: 'end',
        }}
      >
        <img src={closeLogo} />
      </IconButton>
      <div className={styles.formWrapper}>
        {!isSignUpFormFilled && isLogin && (
          <>
            <h2
              onClick={() => {
                setIsLogin(false)
              }}
              className={styles.title}
            >
              Already have an account? <u>Log In</u>
            </h2>
            <SignUpForm onSignUpSuccess={handleClose} />
          </>
        )}
        {!isSignUpFormFilled && !isLogin && (
          <>
            <h2
              onClick={() => {
                setIsLogin(true)
              }}
              className={styles.title}
            >
              Don’t have an account? <u>Sign Up</u>
            </h2>
            <SignInForm onLoginSuccess={handleClose} />
          </>
        )}
      </div>
      {!isSignUpFormFilled && !isLogin && (
        <span
          style={{
            fontSize: 14,
            letterSpacing: 0.5,
            color: '#002933',
            cursor: 'pointer',
            display: 'block',
            textAlign: 'center',
            alignSelf: 'end',
            padding: '16px',
            marginTop: 16,
            textDecoration: 'underline',
          }}
          onClick={() => setOpenForgotPasswordModal(true)}
        >
          Forgot Password?
        </span>
      )}
      <ForgotPasswordModal
        open={openForgotPasswordModal}
        handleClose={setOpenForgotPasswordModal}
        resetEmailSent={false}
      />
    </Dialog>
  )
}
